<template>

    <div>
        <div class="themePan">
            <el-radio-group v-model="query.tb" size="mini" @change="tableChange" >
                <el-radio v-for="item in selectData['tableMap']" :key="item.id" :label="item.tb" border>{{ item.name }}</el-radio>
            </el-radio-group>
        </div>
        <el-card shadow="hover"  class="searchCard" >
            <span class="label-span">
                <label class="label">订单时间</label>
                <el-date-picker style="width:200px"
                                v-model="query.orderTime"
                                @change="handleMonthChange"
                                type="month"
                                value-format="yyyy-MM"
                                placeholder="选择年月"
                                class="mr10">
                </el-date-picker>
            </span>
            <span class="label-span">
                <label class="label">下游渠道</label>
                <el-select v-model="query.memId" placeholder="下游渠道" filterable clearable style="width:200px"
                           class="handle-select mr10">
                    <el-option value="" label="全部" />
                    <el-option v-for="item in selectData['memberOption']" :key="item.optKey" :label="item.optVal"
                               :value="item.optKey" />
                </el-select>
            </span>

            <span class="label-span">
                    <label class="label">产品名称</label>
                    <el-input v-model.trim="query.goodsName" placeholder="产品名称"  class="handle-input mr10"></el-input>
                </span>
            <span class="label-span">
                    <label class="label">产品编码</label>
                    <el-input v-model.trim="query.goodsCode" placeholder="产品编码" class="handle-input mr10"></el-input>
                </span>
            <span class="label-span">
                <label class="label">结算状态</label>
                <el-select v-model="query.downSettlStatusQuery" placeholder="结算状态" filterable clearable
                           class="handle-select mr10">
                    <el-option value="" label="全部" />
                    <el-option v-for="item in selectData['downSettlStatusOption']" :key="item.optKey" :label="item.optVal"
                               :value="item.optKey" />
                </el-select>
            </span>
            <br>
            <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
            <el-button type="error" icon="el-icon-refresh" class="mr10"  @click="refreshSearch">重置</el-button>
            <el-button type="error" icon="el-icon-download" class="mr10" @click="downExcel">导出</el-button>
            <el-button type="danger" class="mr10" @click="createChannelErs">生成结算函</el-button>
            <el-button type="primary" class="mr10" @click="handleStatusMore">状态变更</el-button>
<!--            <el-popconfirm title="确定要进行数据校准吗？"  class="mr10" @confirm="ersUpdate">-->
<!--                <el-button slot="reference" icon="el-icon-aim">数据校准</el-button>-->
<!--            </el-popconfirm>-->
<!--            <el-button type="danger" @click="cashChange">CPA 调价</el-button>-->
<!--            <div :hidden="!ersTbVisible" style="margin:40px 20% 50px;">-->
<!--                <h3 >正在校准 : <span> {{formRedis.message}} ({{ formRedis.success}}/{{formRedis.total }}</span>) <i class="el-icon-loading ml15"></i></h3> <br></br>-->
<!--                <el-progress :text-inside="true" :stroke-width="20" :percentage="formRedis.rate" color="#ff0000 "></el-progress>-->
<!--            </div>-->
        </el-card>
        <el-card shadow="hover"  class="containCard" >
            <el-table :data="tableData" :height="theight" border class="table"  ref="multipleTable" header-cell-class-name="table-header"
                      v-loading="loading"  element-loading-text="" element-loading-spinner="el-icon-loading">

                <el-table-column prop="mid" min-width="110" align="center" label="渠道名称">
                    <template slot-scope="scope">
                        {{formatSelect('memberOption',scope.row.mid)}}
                    </template>
                </el-table-column>
                <el-table-column prop="goodsCode" min-width="120" align="center" label="产品编码"> </el-table-column>
                <el-table-column prop="goodsName" min-width="200" align="center" label="产品名称"> </el-table-column>
                <el-table-column prop="orderDate" min-width="120" align="center" label="订购日期"> </el-table-column>
                <el-table-column prop="downSettlPrice"  min-width="120" align="center" label="产品单价">
                    <template slot-scope="scope">
                        <b class='red'>{{scope.row.downSettlPrice}} </b>
                    </template>
                </el-table-column>
                <el-table-column prop="downSettlStatus" min-width="90" align="center" label="结算状态">
                    <template slot-scope="scope">
                        {{formatSelect('downSettlStatusOption',scope.row.downSettlStatus)}}
                    </template>
                </el-table-column>
                <el-table-column prop="num" min-width="90" align="center" label="结算数量"> </el-table-column>
                <el-table-column prop="totalPrice"  min-width="120" align="center" label="结算总价">
                    <template slot-scope="scope">
                        <b class='red'>{{scope.row.totalPrice}} </b>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50, 100, 200,500,1000,2000]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange"
                ></el-pagination>
            </div>
        </el-card>

        <!-- 新建自主资源弹出框 -->
        <el-dialog :close-on-click-modal="false" title="状态变更" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="420px">
            <el-form ref="form1" :model="form1" label-width="90px">
                <el-form-item label="订单状态">
                    <el-radio-group  v-model.trim="form1.status" >
                        <el-radio-button v-for="item in selectData['downSettlStatusOption']"
                                         v-if="item.optKey !== '1'" :label="item.optKey">{{item.optVal}}</el-radio-button>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm(form1.status)">确 定</el-button>
            </span>
        </el-dialog>



        <!-- 编辑自主资源弹出框 -->
        <el-dialog :close-on-click-modal="false" title="结算函" v-loading="loading2" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="1120px">
            <div>
                <div style='margin-top:-20px;'>
                    <span class="label-span">
                        <label class="label2">业务方</label>
                        <el-select v-model="form2.ywCompany" @change="setCompany('1',form2.ywCompany)" placeholder="业务方" filterable  clearable class="handle-select mr10">
                            <el-option v-for="item in selectData['ersAccountOption']" :key="item.optKey" :label="item.optVal" :value="item.optKey" />
                        </el-select>
                    </span>
                    <span class="label-span" style='margin-right:20px'>
                        <label style='margin:0 10px'>签章</label>
                        <el-tooltip :content="form2.ywCompanyStamp=='1'?'已开启':'已关闭'" placement="top">
                            <el-switch
                                       v-model="form2.ywCompanyStamp"
                                       active-color=""
                                       inactive-color=""
                                       active-value="1"
                                       inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </span>
                    <span class="label-span">
                        <label class="label2">推广方</label>
                        <el-select v-model="form2.tgCompany" @change="setCompany('2',form2.tgCompany)" placeholder="推广方" filterable  clearable class="handle-select mr10">
                             <el-option v-for="item in selectData['ersAccountOption']" :key="item.optKey" :label="item.optVal" :value="item.optKey" />
                        </el-select>
                    </span>
                    <span class="label-span" style='margin-right:20px'>
                        <label style='margin:0 10px'>签章</label>
                        <el-tooltip :content="form2.tgCompanyStamp=='1'?'已开启':'已关闭'" placement="top">
                            <el-switch
                                        v-model="form2.tgCompanyStamp"
                                        active-color=""
                                        inactive-color=""
                                        active-value="1"
                                        inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </span>
                </div>

                <!-- 目标转换区域，通过 ref 标记 -->
                <div ref="captureElement"  >
                    <!-- 需转换为图片的HTML内容 -->
                    <h1 style='text-align: center;margin:15px 0 10px 0;'>广州银象结算函</h1>
                    <div :hidden="!ersTbVisible" style="margin:40px 20% 50px;">
                        <h3 >正在校准 : <span> {{formRedis.message}} ({{ formRedis.success}}/{{formRedis.total }}</span>) <i class="el-icon-loading ml15"></i></h3> <br></br>
                        <el-progress :text-inside="true" :stroke-width="20" :percentage="formRedis.rate" color="#ff0000 "></el-progress>
                    </div>
                    <table class='myTable' style='margin-top:15px;' :hidden="ersTbVisible">
                        <tr class='myTable_th'>
                            <td style='width:80px' data-html2canvas-ignore>上游渠道</td>
                            <td style='width:170px'>结算账期</td>
                            <td >业务名称</td>
                            <td style='width:60px'>推广量</td>
                            <td style='width:60px'>单价</td>
                            <td style='width:70px'>应结</td>
                            <td style='width:60px'>核减</td>
                            <td style='width:100px'>备注</td>
                            <td style='width:80px'>实结</td>
                        </tr>
                        <tr  class='myTable_tr' v-for="(item,index) in cashList" :key="index">
                            <td data-html2canvas-ignore>{{formatSelect("channelOption",item.upid,{defKeyValue:""})}}</td>
                            <td>{{ query.orderTimeArr[0] }} - {{ query.orderTimeArr[1] }}</td>
                            <td>{{ item.goodsName }}</td>
                            <td>{{ item.num }}</td>
                            <td>{{ item.downSettlPrice }}</td>
                            <td>{{ item.totalPrice }}</td>
                            <td><input class='inputHidden' @change='cashHj(item)'  oninput="value=value.replace(/[^0-9.-]/g,'')" style='width:50px;text-align: left' v-model.trim = "item.fb1"></td>
                            <td><input class='inputHidden' style='width:90px;text-align: left' v-model.trim = "item.fb2"></td>
                            <td :class="'totalSj'+index">{{ item.fb3 }}</td>
                        </tr>
                        <tr  class='myTable_tr'>
                            <td colspan='1' style='border-right:none' data-html2canvas-ignore></td>
                            <td colspan='2' style='text-align: right;border:none;font-weight: bold'>统计：</td>
                            <td colspan='2' style='text-align: left;border:none;font-weight: bold'>{{ form.totalNum }}</td>
                            <td colspan='3' style=' border:none;font-weight: bold'>{{ form.totalSum }}</td>
                            <td class='totalSumSj' style='border:none;font-weight: bold'>{{form.totalSumSj}}</td>
                        </tr>
                        <tr  class='myTable_tr'  >
                            <td colspan='1' data-html2canvas-ignore></td>
                            <td colspan='3' >
                                <b>业务方：</b><span v-if='this.ywCompany'>&nbsp;&nbsp;&nbsp;{{ywCompany.companyName}}<br>
                                <b>公司税号：</b>{{ywCompany.companyCode}}<br>
                                <b>开户银行：</b>{{ywCompany.bankName}}<br>
                                <b>银行账户：</b>{{ywCompany.bankCardNum}}<br>
                                <b>公司地址：</b>{{ywCompany.companyAddress}}<br>
                                <b>联系电话：</b>{{ywCompany.companyTel}}</span>
                                <img :src='ywCompany.stamp' class='stampImg' :hidden='form2.ywCompanyStamp==0'>
                            </td>
                            <td colspan='5' >
                                <b>推广方：</b><span v-if='this.tgCompany'>&nbsp;&nbsp;&nbsp;{{tgCompany.companyName}}<br>
                                <b>公司税号：</b>{{tgCompany.companyCode}}<br>
                                <b>开户银行：</b>{{tgCompany.bankName}}<br>
                                <b>银行账户：</b>{{tgCompany.bankCardNum}}<br>
                                <b>公司地址：</b>{{tgCompany.companyAddress}}<br>
                                <b>联系电话：</b>{{tgCompany.companyTel}}</span>
                                <img :src='tgCompany.stamp' class='stampImg' :hidden='form2.tgCompanyStamp==0'>
                            </td>
                        </tr>
                    </table>

                </div>

                <div style="margin-top: 10px;">
                    <el-button class="mr10" @click="exportToImage" icon="el-icon-lx-down">下载</el-button>
                    <el-popconfirm title="确定要进行下游结算吗？"  class="mr10" @confirm="settlement">
                        <el-button slot="reference" icon="el-icon-aim">下游结算</el-button>
                    </el-popconfirm>
                    <el-popconfirm title="确定要进行数据校准吗？"  class="mr10" @confirm="ersUpdate">
                        <el-button slot="reference" icon="el-icon-aim">数据校准</el-button>
                    </el-popconfirm>
                    <el-button type="danger" @click="cashChange">CPA 调价</el-button>
                </div>
            </div>
        </el-dialog>

        <el-dialog  :title="query.cname+'结算函'"  :modal-append-to-body='false' :visible.sync="detailVisible" width="800px" top="30px" height="100%" >
            <iframe :src="linkUrl"  frameborder="0" style="margin-top:-15px;" width="100%" height="600px"></iframe>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :title="'CPA 调价' + formatSelect('memberOption',query2.memId,{defKeyValue:'',defValueValue:'（未知）',prefix:'（',suffix:'）'})"
                   :modal="false" :modal-append-to-body='false' :visible.sync="cashChangeVisible" top="0" width="450px">
            <el-form ref="query2" :model="query2" label-width="90px" :rules="query2Rules">
                <span class="label-span">
                    <el-form-item prop="startTime" label="" label-width="0">
                        <label class="label">订单开始日期</label>
                        <el-date-picker v-model="query2.startTime" :picker-options="pickerOptions1"
                                        value-format='yyyy-MM-dd' placeholder="开始日期" style="width:300px;"> </el-date-picker>
                    </el-form-item>
                </span>
                <span class="label-span">
                    <el-form-item prop="endTime" label="" label-width="0">
                        <label class="label">订单结束日期</label>
                        <el-date-picker v-model="query2.endTime" :picker-options="pickerOptions1"
                                        value-format='yyyy-MM-dd' placeholder="结束日期" style="width:300px;" class="mr10"> </el-date-picker>
                    </el-form-item>
                </span>
                <span class="label-span">
                    <el-form-item prop="goodsCode" label="" label-width="0">
                        <label class="label">产品名称</label>
                        <el-select v-model="query2.goodsCode"  placeholder="产品名称" filterable  clearable style="width:300px;">
                            <el-option v-for="item in selectData['goodsOption2']" :key="item.optKey" :label="item.optVal" :value="item.optKey" />
                        </el-select>
                    </el-form-item>
                </span>
                <span class="label-span">
                    <el-form-item prop="goodsCom" label="" label-width="0">
                        <label class="label">CPA 价格</label>
                        <el-input v-model.trim="query2.goodsCom" placeholder="CPA 价格" class="handle-input mr10"></el-input> 元
                    </el-form-item>
                </span>
                <span class="label-span">
                    <el-form-item prop="goodsComStatus" label="" label-width="0">
                        <label class="label">结算状态</label>
                        <el-radio-group v-model.trim="query2.goodsComStatus" >
                            <el-radio-button label="2">待结算</el-radio-button>
                        </el-radio-group>
                    </el-form-item>
                </span>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cashChangeVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm2">{{ isSubmitting ? '提交中...' : '提交' }}</el-button>
            </span>
        </el-dialog>

    </div>

</template>

<script>
import $ from 'jquery' ;
import { fetchListData,downCashExcel,getDataByChannelCash,updateSettlStatus,changeCpa,updateSettle,updateDeduction} from '@/api/orderSettlement';
import {getErsCheck} from '../../api/redisGet';
import {getData} from '../../api/ersAccount';  //渠道名称
import html2canvas from 'html2canvas';
import {
    getCurrentMonth,
    getMonthRange,
    getMonthRangeByCurrent,
    getMonthRangeByYearAndMonth,
} from '@/utils/dateUtils';
import selectManager from '@/utils/selectUtils2';

export default {
    data() {
        return {
            formatSelect:selectManager.formatSelect.bind(selectManager),
            pickerOptions: {
                shortcuts: [{
                    text: '当月',
                    onClick(picker) {
                        picker.$emit('pick', getMonthRangeByCurrent());
                    }
                }, {
                    text: '上月',
                    onClick(picker) {
                        picker.$emit('pick', getMonthRange(1));
                    }
                }, {
                    text: '2月前',
                    onClick(picker) {
                        picker.$emit('pick', getMonthRange(2));
                    }
                }],
                disabledDate(time) {
                    // 禁用今天及今天之后的所有时间
                    const today = new Date();
                    today.setHours(0, 0, 0, 0); // 将时间归零到当天00:00:00
                    return time.getTime() > today.getTime(); // 严格比较当天及之后
                }
            },
            pickerOptions1: {},
            selectData:{
                downSettlStatusOption:[
                    // {optKey:'0',optVal:'待核对',type:'info'},
                    {optKey:'1',optVal:'已结算',type:'success'},
                    {optKey:'2',optVal:'待结算',type:'warning'},
                    {optKey:'3',optVal:'不结算',type:'danger'}
                ],
            },
            query: {
                pageIndex: 1,
                pageSize: 10,
                dataKey:'dowm',
                orderTime: getCurrentMonth(),
                orderTimeArr: getMonthRangeByCurrent(),
                downSettlStatusQuery: '',
                tb:'@',
            },
            tableData: [],

            isSubmitting:false,
            dialogFormVisible: false,
            formLabelWidth: '120px',
            dynamicText: "示例数据",
            imageUrl: "",
            formattedJson: "",
            Timeout:'',
            activeNames:1,
            theight:'480px',
            theight2:'500px',
            myTableIsShowChannel:true,
            ywCompany:'',
            tgCompany:'',
            sendSms:{
                code:'',
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
            },
            formImg:{
                img2:'',
                img3:'',
            },
            formRedis:{},
            timer:"",
            multipleSelection: [],
            delList: [],
            showDiv:true,
            showDiv2:true,
            show:'v',
            show2:'● 查看接口请求数据 >',
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            ersTbVisible:false,
            addPlusVisible:false,
            detailVisible:false,
            linkUrl:'',
            backVisible:false,
            stepVisible:false,
            drawVisible:false,
            cashChangeVisible:false,
            query2:{goodsComStatus:2},
            query2Rules: {
                startTime: [
                    {required: true, message: '请选择订单开始日期', trigger: 'blur' }
                ],
                endTime: [
                    {required: true, message: '请选择订单结束日期', trigger: 'blur' }
                ],
                goodsCode: [
                    {required: true, message: '请选择产品名称', trigger: 'change' }
                ],
                goodsCom: [
                    {required: true, message: '请填写CPA价格', trigger: 'blur' }
                ]
            },
            loading:false,
            loading2:false,
            row:{},
            pageTotal: 0,
            formtd: {
                cid:'',
                startTime:'',
                endTime:'',
                file: ''
            },
            form: {
                totalSumsj:0,
                totalSum:0,
            },
            cashList:[],
            form1: {
                status:'2',
            },
            form2: {ywCompany:'',tgCompany:'',ywCompanyStamp:'0', tgCompanyStamp:'0',  },
            form3: {  phone:'',sms:''  },
            form4: {   },
            form5: {   },
            form6: {   },
            form7: {   },
            idx: -1,
            id: -1,
            ids:'',
        };
    },
    components: {
    },
    created() {
        // 初始化工具类中的Vue实例
        selectManager.initialize(this,this.selectData);
        // 加载下拉框数据
        this.loadDropdownData();
    },
    //页面加载方法
    mounted: function () {
        this.getData();
        // this.$message.warning("只对7天前的订单数据进行财务汇总");
    },
    beforeDestroy() {
        // 离开前保存 query 到本地
        localStorage.setItem('comOrderQuery', JSON.stringify(this.query));
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    },

    methods: {
        handleMonthChange(val) {
            if (!val) {
                this.query.orderTimeArr = [];
                return;
            }
            const [year, month] = val.split('-');
            this.query.orderTimeArr = getMonthRangeByYearAndMonth(year,month);
        },
        updateRange() {
            const [start, end] = this.query.orderTimeArr;
            let startTime = new Date(start);
            let endTime = new Date(end);
            this.$set(this,"pickerOptions1",{
                disabledDate(time) {
                    return time.getTime() <= startTime || time.getTime() >= endTime;
                }
            });
        },
        initPickerOptions(){
            let tb = this.query['tb'];

            if (tb === '@') {
                this.$set(this,"pickerOptions",this.$options.data().pickerOptions);
                return;
            }

            let orderTimeArr = getMonthRangeByYearAndMonth(tb,12)
            this.$set(this.query,"orderTimeArr",orderTimeArr);

            let shortcuts = [];
            for (let i = 12; i > 0; i--) {
                let m = i.toString().padStart(2, '0');
                shortcuts.push({
                    text: tb + '-' + m,
                    onClick: (picker) => {
                        picker.$emit('pick', getMonthRangeByYearAndMonth(tb, i));
                    }
                })
            }
            this.$set(this.pickerOptions,"shortcuts", shortcuts);
            let disabledDate = (time) => {
                const today = new Date(time);
                let year = today.getFullYear().toString()
                return year !== tb;
            }
            this.$set(this.pickerOptions,"disabledDate", disabledDate);
        },
        loadDropdownData() {
            selectManager.getOption("tableMap");
            // 加载下游渠道下拉框数据
            selectManager.getOption("memberOption");
        },
        cashHj(row){
            let param = {
                ...row,
                memId : row['mid'],
                month : this.query.orderTime,
            }
            updateDeduction(param).then(res=>{
                if(res.code=='200'){
                    this.createChannelErs();
                }else{
                    this.$message.error(res.message);
                }
            })

            // var totalSumsj = 0;
            // for(var i=0;i<this.cashList.length;i++){
            //     if(parseFloat(this.cashList[i].totalPrice) < parseFloat(this.cashList[i].fb1)){
            //         this.$message.error("核减金额不得超过应结金额！");
            //         return;
            //     }
            //     if (this.cashList[i].fb3 <=0){
            //         return;
            //     }
            //     var totalSj = parseFloat(this.cashList[i].totalPrice) - parseFloat(this.cashList[i].fb1);
            //     $('.totalSj'+i).text(totalSj);
            //     totalSumsj += totalSj;
            // }
            // this.form.totalSumsj = totalSumsj;
            // $(".totalSumSj").text(totalSumsj)
        },
        setCompany(i,id){
            let data = {};
            data.id = id;
            getData(data).then(res => {
                if(res.code=='200'){
                    if(i==1){
                        this.ywCompany = res.data;
                    }else if(i==2){
                        this.tgCompany = res.data;
                    }
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        getSummaries(param){
            const { columns, data } = param;
            const sums = [];
            this.theight = '480px';
            columns.forEach((column, index) => {
                if (index == 0) {//只找第一列放合计
                    sums[index] = '统计';
                    return;
                }
                if(index < 5   ){
                    sums[index] = '';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));//把对应一列中的之全部取出，放到一个数组中
                if (!values.every(value => isNaN(value))) {//如果el-table-column中没有prop属性，这里的column.property是undefined，所以判断一下values数组是否为空
                    sums[index] = values.reduce((prev, curr) => {
                        console.log(prev, curr);
                        const value = Number(curr);//将values中的每个值转换为number类型
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    if(index == 5){
                        sums[index] += '元';
                    }
                } else {
                    sums[index] = 0
                }
            });
            window.setTimeout(() => {
                this.theight = this.theight2;
            }, 500) ;
            return sums;
        },
        async exportToImage() {
            let _this = this;
            if(!this.form2.ywCompany){
                this.$message.error("请选择业务方");
                return;
            }
            try {
                this.myTableIsShowChannel = false;
                // 获取DOM元素
                const element = this.$refs.captureElement;

                // 配置选项（关键优化）
                    await html2canvas(element, {
                    useCORS: true,      // 解决跨域图片加载问题
                    scale: 2,           // 提高输出分辨率（2倍）
                    backgroundColor: "#ffffff", // 设置白色背景
                    logging: false      // 关闭调试日志
                }).then(function(canvas) {
                    // 转换为DataURL并保存
                    _this.imageUrl = canvas.toDataURL("image/png");
                    _this.downloadImage(canvas);
                })

            } catch (error) {
                console.error("转换失败：", error);
                alert("生成图片失败，请重试");
            }
        },
        downloadImage(canvas) {
            const link = document.createElement("a");
            link.href = canvas.toDataURL("image/png");
            link.download = "截图.png"; // 自定义文件名
            link.click();
        },

        // 触发搜索按钮
        handleSearch() {
            let back = this.validateTimeRange();
            if(back !== 'ok'){
                this.$message.warning(back);
                return;
            }
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){
            let tb = this.query['tb'];
            this.$set(this,"query",this.$options.data().query);
            this.$set(this.query,"tb",tb);
            // this.initPickerOptions();
            this.handleSearch();
        },
        tableChange(){
            this.refreshSearch();
        },

        validateTimeRange() {
            if(!this.query.tb){
                return '请选择数据范围';
            }

            if (!(this.query.orderTimeArr && this.query.orderTimeArr.length === 2)) {
                return 'ok';
            }

            const [start, end] = this.query.orderTimeArr;
            const startTime = new Date(start);
            const endTime = new Date(end);

            if(this.query.tb === '@' ){
                const nowDate = new Date();
                const threeMonthsAgo = new Date(nowDate);
                threeMonthsAgo.setMonth(nowDate.getMonth() - 3);
                if (startTime < threeMonthsAgo) {
                    return '订单时间段超出数据范围';
                }
            }else{
                if (startTime.getFullYear().toString() !== this.query.tb) {
                    return '订单时间段超出数据范围 start：'+this.query.tb;
                }
                if (endTime.getFullYear().toString() !== this.query.tb) {
                    return '订单时间段超出数据范围 end：'+this.query.tb;
                }
            }
            return 'ok';
        },

        getMore(data){
            this.$notify({  message: data,duration: 3000 });
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },

        //触发刷新按钮
        refresh(){
            history.go(0);

        },

        downExcel(){
            this.queryCheck(param=>{
                this.loading = true
                setTimeout( () => {
                    if(this.loading){
                        this.loading = false;
                        this.getData();
                    }
                }, 7000)
                downCashExcel(param).then(res => {
                    this.loading = false
                    if(res.code=='200'){
                        this.$notify({ title: '成功', message: res.message,duration: 5000, type: 'success' });
                    }else{
                        this.$notify({ title: '失败', message: '后台下载异常',duration: 5000, type: 'error' });
                    }
                });
            })
        },
        queryCheck(action){
            let param = {
                ...this.query,
            }
            if(this.query.orderTimeArr && this.query.orderTimeArr.length > 1){
                param.startTime = this.query.orderTimeArr[0] + " 00:00:00";
                param.endTime = this.query.orderTimeArr[1] + " 23:59:59";
            }
            if (!param.startTime || !param.endTime) {
                this.$message({
                    message: '订单时间不能为空',
                    type: 'warning'
                });
                return;
            }
            action(param);
        },
        //查询
        getData(){
            this.queryCheck(param=>{
                this.loading = true;
                fetchListData(param).then(res => {
                    this.loading = false;
                    if(res.code=='200'){
                        this.tableData = res.data.list;
                        this.pageTotal = res.data.pageTotal ;
                    }else{
                        this.tableData = [];
                        this.pageTotal = 0;
                    }
                });
            })
        },

        copyLink(text,name){
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);
            //提示已复制
            this.$message.success(name+"复制成功");
        },


        handleRemarksMore(){
            const length = this.multipleSelection.length;
            if(length===0){
                this.$message.error("请勾选要备注的订单");
                return;
            }
            this.ids = '';
            for (let i = 0; i < length; i++) {
                this.ids += this.multipleSelection[i].id + ',';
            }
            this.ids = this.ids.substr(0,this.ids.length-1);
            this.form3.id = this.ids;
            this.editVisible = true;
        },
        //数据校准
        ersUpdate(){
            this.queryCheck(param=>{
                this.ersTbVisible = true;
                setTimeout( () => {
                    this.redisCoon();
                }, 1500)
                updateSettle(param).then(res => {
                    if(res.code=='200'){
                        this.$message.success('数据校准成功');
                        this.getData();
                    }else{
                        this.$message.error('数据校准失败');
                    }
                });
            })
        },
        settlement(){
            let yjs = this.selectData.downSettlStatusOption[0];
            this.saveForm(yjs['optKey'],()=>this.createChannelErs());
        },
        redisCoon(){
            let data = {}
            this.timer = setInterval(() => {
                getErsCheck(this.query).then(res => {
                    if(res.code=='200' ){
                        if(res.data!=null){
                            this.$set(this, 'formRedis', res.data);
                            this.$forceUpdate();
                            if(res.data.stop==1){
                                clearInterval(this.timer);
                            }
                            if(res.data.end==1){
                                this.ersTbVisible = false;
                                clearInterval(this.timer);
                                // this.createChannelErs();
                            }
                        }
                    }else{
                        this.$message.error(res.message);
                        clearInterval(this.timer);
                    }
                });
            }, 500);
        },

        // 保存更改
        saveEdit() {
            if( !this.form3.remarks ){
                this.$message.error("请填写订单备注");
                return;
            }
            updateMore(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false;
                    this.$message.success(res.message);
                    this.getData();
                }else{
                    this.$message.error(res.message);
                }
            });
        },

        handleStatusMore(){
            this.addVisible = true;
        },
        createChannelErs(){
            this.queryCheck(param=>{
                if (!param.memId) {
                    this.$message({
                        message: '请选择下游渠道',
                        type: 'warning'
                    });
                    return;
                }
                this.loading = true;
                selectManager.getOption('ersAccountOption');
                selectManager.getOption("channelOption");
                getDataByChannelCash(param).then(res => {
                    if(res.code=='200'){
                        this.ersTbVisible = false;
                        this.myTableIsShowChannel = true;
                        this.cashList = res.data.list;
                        this.form.totalSumSj = res.data.totalSumSj;
                        this.form.totalSum = res.data.totalSum;
                        this.form.totalNum = res.data.totalNum;
                        this.editVisible = true;
                        this.loading = false;
                    }else{
                        this.loading = false;
                        this.$message.error(res.message);
                    }
                });
            })

            /*
            const queryString = Object.entries(this.query)
                .filter(([_, value]) => value != null && value !== '') // 过滤空值
                .map(([key, value]) => {
                    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
                }).join('&');
            var mid = localStorage.getItem(window.location.hostname + '_mid');
            var host = localStorage.getItem(window.location.hostname + '_stationUrl');
            this.linkUrl = window.location.protocol + '//' + host + '/h5/cash/channel_'+mid+'?' + queryString; */

        },
        cashChange(){
            selectManager.getOption("goodsOption2");
            this.query2["memId"] = this.query.memId;
            if (this.query.orderTimeArr && this.query.orderTimeArr.length >=2){
                this.$set(this.query2,"startTime",this.query.orderTimeArr[0]);
                this.$set(this.query2,"endTime",this.query.orderTimeArr[1]);
                this.updateRange();
            }

            this.cashChangeVisible = true;
        },
        //保存新增
        saveForm2() {
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮

            this.$refs["query2"].validate((valid) => {
                if (!valid) {
                    this.isSubmitting = false;
                    return;
                }
                let param = {
                    ...this.query2,
                }
                if(this.query.orderTimeArr && this.query.orderTimeArr.length > 1){
                    param.startTime = this.query.orderTimeArr[0] + " 00:00:00";
                    param.endTime = this.query.orderTimeArr[1] + " 23:59:59";
                }
                this.loading2 = true;
                changeCpa(param).then(res => {
                    if(res.code=='200'){

                        let errorHtml = "";
                        if (res.data.errorOrderList){
                            for (const orderNo of res.data.errorOrderList) {
                                errorHtml += `<p>${orderNo}</p>`;
                            }
                        }

                        if (errorHtml){
                            this.$alert(errorHtml, '下列订单下游已结算,禁止调价', {
                                dangerouslyUseHTMLString: true
                            }).then(() => {
                                this.cashChangeVisible = false;
                                this.getData();
                                // this.createChannelErs();
                                this.ersUpdate();
                            });
                        }else {
                            this.cashChangeVisible = false;
                            this.$message.success(res.message);
                            this.getData();
                            // this.createChannelErs();
                            this.ersUpdate();
                        }
                    }else{
                        this.cashChangeVisible = true;
                        this.$message.error(res.message);
                    }
                    this.loading2 = false;
                    this.isSubmitting = false;
                }).catch(e=>{
                    this.$message.error(e);
                    this.loading2 = false;
                    this.isSubmitting = false;
                })
            });
        },
        saveForm(status,fun) {
            this.queryCheck(param=>{
                param['downSettlStatus'] = status;
                updateSettlStatus(param).then(res => {
                    if(res.code=='200'){
                        this.addVisible = false;
                        this.$message.success(res.message);
                        this.getData();
                        if (fun){
                            fun();
                        }
                    }else{
                        this.$message.error(res.message);
                    }
                });
            })
        },

        // q启用、禁用--改变状态
        handleStatus(index, row) {
            var tips ;
            var content;
            if(row.status=='0'){
                tips = "禁用";
                content = "确定禁用吗？";
            }else{
                tips = "启用";
                content = "确定启用吗？";
            }
            // 二次确认删除
            this.$confirm(content, '提示', {
                type: 'warning'
            }).then(() => {
                changeStatus(row).then(res => {
                    if(res.code=='200'){
                        this.$message.success(tips+'成功');
                        this.getData();
                    }else{
                        this.$message.error(tips+'失败');
                    }
                });
            })
                .catch(() => {});

        },


        //详情
        handleDetail( row){
            getOrderDetail(row).then(res => {
                if(res.code=='200'){
                    if(res.data==null){
                        this.$message.error("暂无数据");
                        return;
                    }
                    this.detailVisible = true;
                    this.form2 = res.data;
                    this.form3.phone = row.phone;
                    this.form3.sms = row.sms;
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        handleStep( row){
            getOrderStep(row).then(res => {
                if(res.code=='200'){
                    this.stepVisible = true;
                    //apiCallLogList
                    // comOrderStepList
                    this.form4 = res.data.comOrderStepList;
                    this.form7 = res.data.apiCallLogList;
                    this.form5 = row;
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        handleBack( row){
            getOrderBack(row).then(res => {
                if(res.code=='200'){
                    this.backVisible = true;
                    this.form6 = res.data;
                    this.form5 = row;
                }else{
                    this.$message.error(res.message);
                }
            });
        },
        // 删除
        handDelete(index, row) {
            this.form.id=row.id;
            // 二次确认删除
            this.$confirm('该资源所有商品将删除，是否要删除？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){
                        this.$message.success('删除成功');
                        this.$set(this.query, 'pageIndex', 1);
                        this.getData();
                    }else if(res.code=='201'){
                        //处理该等级绑定的成员
                        this.$message.error("该资源商品仍有订单未结算，请手动结算订单！");
                    }else{
                        this.$message.error("删除失败");
                    }
                });
            })
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        },
        beforeUpload(file) {

            const isValidSize = file.size / 1024 / 1024 < 20;
            const isExcel = file.name.endsWith('.xlsx') || file.name.endsWith('.xls');
            if (!isExcel) {
                this.$message.error('只能上传 Excel 文件 (.xlsx, .xls)');
                return false; // 阻止上传
            }
            return true;
            if (!isValidSize) {
                this.$message.error('文件大小不能超过 20MB');
            }

            return isValidType && isValidSize;
        },
        customUpload(fileObj) {
            const formData = new FormData();
            // 添加文件
            formData.append('file', fileObj.file);
            // 添加其他字段
            formData.append('cid', this.formtd.cid); // 上游资源名称
            formData.append('startTime', this.formtd.startTime); // 开始时间
            formData.append('endTime', this.formtd.endTime); // 结束时间

            // 发送请求
            uploadExcel(formData).then(res => {
                if (res.code === '200') {
                    this.$message.success(res.message);
                    this.dialogFormVisible = false; // 关闭弹窗
                    this.resetFormtd();
                } else {
                    this.$message.error('上传失败: ' + res.message);
                }
            }).catch(err => {
                this.$message.error('上传过程中发生错误: ' + err);
            });
        },
        resetFormtd() {
            this.formtd = {
                cid: '',
                startTime: '',
                endTime: '',
                file: ''
            };
        },
        resetForm(formName) {
            this.$refs[formName].resetFields(); // 重置表单验证
            this.resetFormtd(); // 重置 formtd 数据
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    // 手动触发上传
                    this.$refs.uploadRef.submit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
};
</script>
<style>
.el-drawer__open .el-drawer.ttb {
    height:100% !important;
}
</style>
<style scoped>

:v-deep .el-icon-arrow-right:before {
    color: #1890ff;
    font-size: 20px;
    font-weight: 700;
}

::v-deep .el-table__expand-icon .el-icon-arrow-right:before {

    font-size:15px;
    color:#409EFF;
    text-align: center;
}
::v-deep .el-table__expand-icon--expanded .el-icon-arrow-right:before{
    font-size:15px;
    color:#999;
    text-align: center;
}


.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 145px;
    display: inline-block;
}

.handle-input {
    width: 145px;
    display: inline-block;
}
.handle-del {
    float:right;
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
<style>
.el-table__row--level-1{
    background-color: #efefef !important;
}
.el-table__row--level-1:hover{
    background-color: #efefef !important;
}
.el-table__row--level-1::after{
    background-color: #efefef !important;
}
.el-table--small .el-table__cell{
    padding:3px 2px;
}
.el-table .cell{
    padding:3px 2px;
}
.white-space-pre-line {
    white-space: pre-line; /* 保留换行符，自动合并空格 */
}
.stampImg{
    width:192px;
    margin-top:-180px;
    margin-left: 260px;
}
.el-progress-bar__innerText {
    color: #fff !important;
    margin-left: 20px;

}

.el-progress-bar__outer {
    background-color: rgb(210, 210, 210) !important;
}


input.notborder[disabled] {
    border-bottom: none; /* 移除边框 */
    cursor: not-allowed; /* 禁用光标 */
}
.inputStyle{
    height:28px;
    text-align:center;
    border:none;
    border-bottom:1px solid orange;
    background: none;
    color:orange;
}

.inputStyle::placeholder{
    color:#bbb;
}
.inputStyle:focus {
    outline:none;
    border-bottom:2px solid red;
}

.label-span{
    margin-bottom: 10px;
}

</style>
